import React, { Component } from 'react';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
class UserProductGroupsModal extends Component {
  constructor() {
    super();
    this.state = {
      groups: [],
    }
  }
  componentDidMount() {

    if (this.props.groups && this.props.groups.length > 0) {
      this.setState({
        groups: this.props.groups,
      })
    }
  }

  handleChangeProductGroups(id, checked) {
    let cpGroups = [];
    if (id == -2) {
      cpGroups = this.state.groups.map(item => {
        return { ...item, checked: checked }
      })
    } else {
      cpGroups = this.state.groups.map(item => {
        if (item.value == id) {
          return { ...item, checked: checked }
        } else {
          return { ...item };
        }
      })
    }

    this.setState({
      groups: cpGroups,
    })
  }

  render() {
    const { onChangeProductGroups, onClose } = this.props;
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ overflowY: 'scroll', height: '200px' }}>
          {this.state.groups.map(item => {
            return <div>
              <input type="checkbox" checked={item.checked} onChange={(event) => {
                this.handleChangeProductGroups(item.value, event.target.checked)
              }} />
              <span>{item.label}</span>
            </div>
          })}
        </div>
        <ButtonToolbar>
          <Button onClick={() => {
            onClose()
          }} bsStyle="danger" > <Translate value="cancel" />
          </Button>
          <Button onClick={() => {
            onChangeProductGroups(this.state.groups)
          }} bsStyle="success" ><Translate value="save" />
          </Button>
        </ButtonToolbar>

      </div>

    );
  }
}

export default UserProductGroupsModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/UserProductGroupsModal.jsx